<template lang="pug">
  #quotation-list
    template(v-if="isScreenLoading === true")
      loading(:height="200")
    template(v-else)
      //- メッセージフォーム
      app-messages(:errorMessages="errors")
      b-card(header-tag="header")
        b-container(fluid="fluid")
          b-row
            b-col.ml-3.mr-3
              b-form-text ※有効期限が切れていない見積書のみ表示しています。
              b-form-text ※変更反映後の総額費用の見積書を『総額見積書』と表示しています。
              b-form-text ※変更分のみの差分費用の見積書を『個別見積書』と表示しています。
              b-form-text.mb-3 ※見積書一覧内の個別見積書や総額見積書の見積金額には、初期費用を除く金額を表示しています。
              h3.font-weight-bold 見積書一覧
              b-card-text
                b-table(
                  bordered,
                  small,
                  striped,
                  hover,
                  show-empty,
                  head-variant="light",
                  :items="quotation_info",
                  :fields="fields",
                  no-local-sorting=true,
                  :busy="isTableLoading"
                )
                  template(#table-busy)
                    loading
                  template(#cell()="data")
                    .pt-1
                      span(:title="data.value") {{data.value}}
                  template(#cell(quotation_no)="data")
                    .d-flex.justify-content-end
                      span.pt-1 {{data.value}}
                  template(#cell(created_user)="data")
                    .pt-1
                      span(:class="data.item.account_delete_flg === '1' ? 'delete-user' : ''") {{data.value}}
                  template(#cell(quoted_amount)="data")
                    .d-flex.justify-content-end
                      span.pt-1 {{ data.value }}
                  template(#cell(buttons)="data")
                    .d-flex.justify-content-center
                      template(v-if="data.item.order_flg === '1'")
                        span.mt-1.ordered-text 申し込み済み
                      template(v-else)
                        b-button.mr-3(variant="outline-primary", size="sm", @click="applyWithQuotation(data.item)", :disabled="isDisabled")
                          b-icon.mr-2(icon="cart", aria-hidden="true")
                          span 見積書の内容で申し込み
                      b-button.mr-3(variant="outline-success", @click="downloadQuotationPDF(data.item)", size="sm", :disabled="isDisabled")
                        b-icon.mr-2(icon="download", aria-hidden="true" )
                        span ダウンロード
                      b-button(variant="outline-danger", @click="openModalConfirmDeleteQuotation(data.item)", size="sm", :disabled="isDisabled")
                        b-icon.mr-2(icon="trash", aria-hidden="true" )
                        span 削除
                  template(#empty)
                    .text-center
                      p 有効な見積書はありません。
        modal-confirm-delete-quotation(:quotation_info="selected_quotation_info", @getQuotation="getQuotation")
</template>

<script>
import Api from "@/repositories/api";
import AppMessages from '@/components/AppMessages.vue';
import Loading from "@/components/Loading";
import ModalConfirmDeleteQuotation from '@/components/supportSite/ModalConfirmDeleteQuotation.vue';
import { quotation_type } from '@/lang/ja_JP';

const C206ContractInfo = Api.get('c206ContractInfo');
const S214QuotationRepository = Api.get("s214Quotation");

export default {
  name: "QuotationList",
  components: {
    AppMessages,
    Loading,
    ModalConfirmDeleteQuotation
  },
  data () {
    return {
      // 表のヘッダー
      fields: [
        { key: 'quotation_no', label: '見積書番号' },
        { key: 'created_user', label: '作成者' },
        { key: 'expiration_date', label: '有効期限' },
        { key: 'quotation_kind', label: '見積書種類' },
        { key: 'quoted_amount', label: '見積金額' },
        { key: 'buttons', label: '' },
      ],
      // 見積書一覧情報
      quotation_info: [],
      // 選択された見積書情報
      selected_quotation_info: {},

      // 顧客番号
      client_no: '',
      // 契約番号
      contract_no: '',
      // 見積書種類
      quotation_type: quotation_type,

      // エラーメッセージ
      errors: [],

      // 画面読み込み中フラグ
      isScreenLoading: false,
      // テーブル読み込み中フラグ
      isTableLoading: false,
      // ボタン無効フラグ
      isDisabled: false,
    }
  },
  created() {
    // // 画面読み込みローディング開始
    this.isScreenLoading = true

    // 販売種別利用制限チェックを行う
    this.validateSalesChannel()

    // ローカルストレージに顧客番号が存在する場合
    if (localStorage.getItem('client_no') !== null) {
      // 顧客番号を取得する
      this.client_no = localStorage.getItem('client_no')
    }

    // 契約番号の取得する
    this.getContractNo()
  },
  methods: {
    /**
     * 契約番号の取得する
     */
    getContractNo() {
      // 画面パラメータに契約番号が存在する場合
      if ('contract_no' in this.$route.params) {
        // 契約番号を設定
        this.contract_no = this.$route.params.contract_no
        // 画面読み込み完了
        this.isScreenLoading = false
        // 見積書一覧情報を取得する
        this.getQuotation()
      }
      // 画面パラメータに契約番号が存在しない場合
      else {
        // C20601_契約情報取得処理を実行
        C206ContractInfo.get({})
          .then((response) => {
            // 取得した契約情報数が1件の場合
            if (response.data.data.length === 1) {
              // 契約番号を設定
              this.contract_no = response.data.data[0].contract_no
              // 見積書一覧情報を取得する
              this.getQuotation()
            }
            // 上記以外の場合
            else {
              // セッションストレージに前画面を保存
              sessionStorage.setItem('previous', 'QuotationList')
              // S11500_ご契約環境選択画面に遷移
              this.$router.push({ name: 'ContractSelect' })
            }
          })
          .catch((error) => {
            // 共通のエラー処理
            this.apiError(error, '画面表示処理', "Support")
          })
          .finally(() => {
            // 画面読み込み完了
            this.isScreenLoading = false
          })
      }
    },
    /**
     * 見積書一覧取得APIを実行する
     */
    getQuotation() {
      // テーブル読み込み中
      this.isTableLoading = true

      // S21401_見積書一覧取得処理
      S214QuotationRepository.view({'contract_no': this.contract_no})
        // 成功時
        .then((response) => {
          // 見積一覧情報を整形する
          this.quotation_info = response.data.quotation_info.map(item => {
            return {
              'quotation_no': this.client_no + '-' + item.estimate_branch,
              'created_user': item.user_name,
              'account_delete_flg': item.account_delete_flg,
              'expiration_date': item.expiration_date !== null ? item.expiration_date.replace(/-/g, '/') : '',
              'estimate_type': item.estimate_type,
              'quotation_kind': quotation_type[item.estimate_type],
              'quoted_amount': item.estimate_cost !== null ? '￥ ' + item.estimate_cost.toLocaleString() : '',
              'estimate_branch': item.estimate_branch,
              'contract_no': item.contract_no,
              'order_flg': item.order_flg,
            }
          })
        })
        .catch((error) => {
          // エラーレスポンスがある場合
          if (error.response && 'status' in error.response) {
            // 共通のエラー処理
            this.apiError(error, '見積書一覧取得処理', "Support")

            // バリデーションエラー
            if (error.response.data.error_list) {
              for (let errorData of error.response.data.error_list) {
                // エラーメッセージをセット
                this.errors.push(errorData.error_msg)
              }
            }
          }
          // エラーレスポンスがない場合
          else {
            // エラーメッセージをセットする
            this.setErrors(error)
          }
        })
        .finally(() => {
          // テーブル読み込み完了
          this.isTableLoading = false
        })
    },
    /**
     * 確認画面に遷移する
     */
    applyWithQuotation(item) {
      // ボタンを無効化する
      this.isDisabled = true

      // セッションストレージに保存
      sessionStorage.setItem('estimate_branch', item.estimate_branch);
      sessionStorage.setItem('contract_no', item.contract_no);

      // 見積書種別が「プラン変更見積書」の場合
      if (item.estimate_type === '4') {
        // プラン変更確認画面に遷移する
        this.$router.push({ name: 'ConfirmChangePlan' })
      }
      // 上記以外の場合
      else {
        // 見積書申込画面へ遷移する
        this.$router.push({ name: 'ConfirmChanges' })
      }
    },
    /**
     * 見積書PDFをダウンロードする
     */
    downloadQuotationPDF(item) {
      // ボタンを無効化する
      this.isDisabled = true
      // エラーメッセージの初期化
      this.errors = []

      // S21404_見積書取得処理
      S214QuotationRepository.get({estimate_branch: item.estimate_branch})
        // 成功時
        .then((response) => {
          // ファイル名を取得する
          let title = response.headers['content-disposition'].replace('attachment; filename*=UTF-8\'\'', '')
          // PDFをダウンロードする
          this.downloadBlobFile(response.data, title, 'application/pdf')
        })
        .catch((error) => {
          // エラーレスポンスがある場合
          if (error.response && 'status' in error.response) {
            // 共通のエラー処理
            this.apiError(error, '見積書取得処理', "Support")

            // バリデーションエラー
            if (error.response.data.error_list) {
              for (let errorData of error.response.data.error_list) {
                // エラーメッセージをセット
                this.errors.push(errorData.error_msg)
              }
            }
          }
          // エラーレスポンスがない場合
          else {
            // エラーメッセージをセットする
            this.setErrors(error)
          }
        })
        .finally(() => {
          // ボタンを有効化する
          this.isDisabled = false
        })
    },
    /**
     * 見積書削除の確認ダイアログを開く
     */
    openModalConfirmDeleteQuotation(item) {
      // 選択した見積情報を設定
      this.selected_quotation_info = item

      // ダイアログを開く
      this.$bvModal.show('modal-confirm-delete-quotation')
    },
  }
}
</script>

<style scoped>
.ordered-text {
  padding-left: 51px;
  padding-right: 50px;
  margin-right: 16px;
}
.delete-user {
  text-decoration: line-through;
}
</style>
